import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "PageView",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/HomePage"], resolve),
          meta: {
            title: "思睿集团-让配置更科学，让投资变简单"
          }
        },
        {
          path: "/team-intro",
          name: "teamIntro",
          component: resolve => require(["@/view/team-intro"], resolve),
          meta: {
            title: "股东和团队"
          }
        },
        {
          path: "/multi-assets",
          name: "MultiAsseets",
          component: resolve => require(["@/view/multi-assets"], resolve),
          meta: {
            title: "多资产投资"
          }
        },
        {
          path: "/credit-property",
          name: "CreditProperty",
          component: resolve => require(["@/view/credit-property"], resolve),
          meta: {
            title: "不动产投资"
          }
        },

        {
          path: "/multi-family",
          name: "MultiFamily",
          component: resolve => require(["@/view/multi-family"], resolve),
          meta: {
            title: "多家族办公室"
          }
        },
        {
          path: "/company-option",
          name: "CompanyOption",
          component: resolve => require(["@/view/company-option"], resolve),
          meta: {
            title: "企业见解"
          }
        },

        {
          path: "/company-news",
          name: "CompanyNews",
          component: resolve => require(["@/view/company-news"], resolve),
          meta: {
            title: "企业新闻"
          }
        },

        {
          path: "/company-news-detail",
          name: "CompanyNewsDetail",
          component: resolve => require(["@/view/company-news-detail"], resolve),
          meta: {
            title: "企业新闻详情"
          }
        },

        {
          path: "/company-option-detail",
          name: "CompanyNewsDetail",
          component: resolve => require(["@/view/company-option-detail"], resolve),
          meta: {
            title: "企业见解详情"
          }
        },
        {
          path: "/company-honor",
          name: "CompanyHonor",
          component: resolve => require(["@/view/company-honor"], resolve),
          meta: {
            title: "企业荣誉"
          }
        },


        {
          path: "/contact-us",
          name: "ContactUs",
          component: resolve => require(["@/view/contact-us"], resolve),
          meta: {
            title: "联系我们"
          }
        },

        {
          path: "/join-us",
          name: "JoinUs",
          component: resolve => require(["@/view/join-us"], resolve),
          meta: {
            title: "加入我们"
          }
        },

        {
          path: "/company-research",
          name: "CompanyResearch",
          component: resolve => require(["@/view/company-research"], resolve),
          meta: {
            title: "思睿研究"
          }
        },

        {
          path: "/company-research-detail",
          name: "CompanyResearchDetail",
          component: resolve => require(["@/view/company-research-detail"], resolve),
          meta: {
            title: "思睿研究详情"
          }
        },

        {
          path: "/outside-assets",
          name: "OutsideAssets",
          component: resolve => require(["@/view/outside-assets"], resolve),
          meta: {
            title: "外部投资"
          }
        },






        {
          path: "/software",
          name: "software",
          component: resolve => require(["@/view/Software"], resolve),
          meta: {
            title: "软件产品"
          },
          children: [
            {
              path: "/software",
              redirect: "/software/smartTown"
            },
            {
              path: "/software/smartTown",
              name: "software",
              component: resolve =>
                require(["@/view/Software_smartTown"], resolve),
              meta: {
                title: "软件产品丨智能小镇管理系统"
              }
            },
            {
              path: "/software/bigData",
              name: "software",
              component: resolve =>
                require(["@/view/Software_bigData"], resolve),
              meta: {
                title: "软件产品丨大数据管理系统"
              }
            }
          ]
        },
        {
          path: "/service",
          name: "service",
          component: resolve => require(["@/view/Service"], resolve),
          meta: {
            title: "相关服务"
          }
        },
        {
          path: "/newsinformation",
          name: "newsinformation",
          component: resolve => require(["@/view/NewsInformation"], resolve),
          meta: {
            title: "新闻动态"
          }
        },
        {
          path: "/companyintroduction",
          name: "companyintroduction",
          component: resolve =>
            require(["@/view/CompanyIntroduction"], resolve),
          meta: {
            title: "公司介绍"
          }
        },
        {
          path: "/jobchance",
          name: "jobchance",
          component: resolve => require(["@/view/JobChance"], resolve),
          meta: {
            title: "工作机会"
          }
        },
        {
          path: "/contactus",
          name: "contactus",
          component: resolve => require(["@/view/ContactUs"], resolve),
          meta: {
            title: "联系我们"
          }
        },
        {
          path: "/servicedetail",
          name: "servicedetail",
          component: resolve => require(["@/view/ServiceDetail"], resolve),
          meta: {
            title: "相关服务"
          }
        },




      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js